const LOCALE_MAP: Record<string, string> = {
  en: "en-GB",
};

export function formatDateTimeDisplay(
  iso: string | null | undefined,
  locale = "en-GB"
): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat(LOCALE_MAP[locale] ?? locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .format(new Date(iso))
    .replace(", at", ",");
}

const DEFAULT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
};

export function formatDateDisplay(
  dateStr: string,
  locale = "en-GB",
  options: Intl.DateTimeFormatOptions = DEFAULT_OPTIONS
) {
  const resolvedLocale = LOCALE_MAP[locale] ?? locale;
  return new Date(dateStr).toLocaleDateString(resolvedLocale, options);
}

export function formatDateTimeApi(isoDate: string): string {
  const d = new Date(isoDate);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
